import { ChangeDetectionStrategy, Component, effect, Input, input, InputSignal, model, ModelSignal, OnInit, output, OutputEmitterRef, signal, WritableSignal } from '@angular/core';
import { PDropdownOptions } from '../../interfaces';
import { SelectModule } from 'primeng/select';
import { FormGroup, FormsModule } from '@angular/forms';
import { NgClass, TitleCasePipe } from '@angular/common';
import {  TestResultType } from './chart-card/chart-card.component';


export interface FilterOption {
  label: string;
  key: string;
  dropdownOptions: PDropdownOptions[];
};

@Component({
  selector: 'co-base-dashboard-chart',
  imports: [SelectModule, FormsModule],
  templateUrl: './base-dashboard-chart.component.html',
  // styleUrl: './base-dashboard-chart.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class BaseDashboardChartComponent {
  // filterOptions: WritableSignal<FilterOption[]> = signal([]);
  // filtersForm:InputSignal<FormGroup> =input.required();
  filterOptions: InputSignal<FilterOption[]> = input.required();
  chartHeader: InputSignal<string> = input.required();
  cssClass: InputSignal<string> = input.required();
  // testResult: InputSignal<TestResultType> = input.required();

  testResult = input<TestResultType | null>();

  onFilterChange: OutputEmitterRef<Record<string, any>> = output();

  @Input() selectedFilters!: Record<string, any>;

  constructor() { }
  onDropdownChange() {
    this.onFilterChange.emit(this.selectedFilters)
  }

}
